import React from 'react'
import { Layout, SEO } from '../components'

export default function () {
  const title = `Resource`
  const description = 'Resource'
  return (
    <Layout>
      <SEO title={title} description={description} />
      <h1>Resource {title}</h1>
      <p>
        We're the only site running on your computer dedicated to showing the
        best photos and videos of pandas eating lots of food.
      </p>
    </Layout>
  )
}
